module.exports = __webpack_public_path__ + "img/icon_kefu.33bc238c.png";